import { useState, useEffect, useRef, useCallback } from "react";

// ─── ICON SYSTEM ───
const icons = {
  search: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>,
  phone: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></svg>,
  mail: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>,
  msg: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22z" /></svg>,
  user: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
  users: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>,
  plus: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M5 12h14" /><path d="M12 5v14" /></svg>,
  clock: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
  dollar: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" x2="12" y1="2" y2="22" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>,
  chart: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 3v18h18" /><path d="m19 9-5 5-4-4-3 3" /></svg>,
  bell: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></svg>,
  chevDown: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="m6 9 6 6 6-6" /></svg>,
  chevRight: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="m9 18 6-6-6-6" /></svg>,
  x: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>,
  check: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M20 6 9 17l-5-5" /></svg>,
  edit: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" /></svg>,
  trash: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 6h18" /><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" /><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" /></svg>,
  file: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" /><path d="M14 2v4a2 2 0 0 0 2 2h4" /></svg>,
  star: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>,
  filter: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>,
  grid: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect width="7" height="7" x="3" y="3" rx="1" /><rect width="7" height="7" x="14" y="3" rx="1" /><rect width="7" height="7" x="14" y="14" rx="1" /><rect width="7" height="7" x="3" y="14" rx="1" /></svg>,
  list: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="8" x2="21" y1="6" y2="6" /><line x1="8" x2="21" y1="12" y2="12" /><line x1="8" x2="21" y1="18" y2="18" /><line x1="3" x2="3.01" y1="6" y2="6" /><line x1="3" x2="3.01" y1="12" y2="12" /><line x1="3" x2="3.01" y1="18" y2="18" /></svg>,
  target: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /></svg>,
  refresh: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" /><path d="M8 16H3v5" /></svg>,
  tag: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" /><circle cx="7.5" cy="7.5" r=".5" fill="currentColor" /></svg>,
  play: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="6 3 20 12 6 21 6 3" /></svg>,
  pause: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor" stroke="none"><rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" /></svg>,
  mic: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" /><path d="M19 10v2a7 7 0 0 1-14 0v-2" /><line x1="12" x2="12" y1="19" y2="22" /></svg>,
  send: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="m22 2-7 20-4-9-9-4Z" /><path d="m22 2-11 11" /></svg>,
  home: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>,
  settings: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" /><circle cx="12" cy="12" r="3" /></svg>,
  arrowUp: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="m5 12 7-7 7 7" /><path d="M12 19V5" /></svg>,
  arrowDown: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 5v14" /><path d="m19 12-7 7-7-7" /></svg>,
  calendar: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect width="18" height="18" x="3" y="4" rx="2" /><line x1="16" x2="16" y1="2" y2="6" /><line x1="8" x2="8" y1="2" y2="6" /><line x1="3" x2="21" y1="10" y2="10" /></svg>,
  link: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>,
  box: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" /><path d="m3.3 7 8.7 5 8.7-5" /><path d="M12 22V12" /></svg>,
  shield: (s = 16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" /></svg>,
};
const I = (name, size = 16) => icons[name] ? icons[name](size) : null;

// ─── LIGHT THEME PALETTE ───
const T = {
  bg: '#EDE8E1',
  sidebar: '#1a1726',
  sidebarText: 'rgba(255,255,255,0.45)',
  sidebarActive: '#FFFFFF',
  sidebarActiveBg: 'rgba(99,102,241,0.15)',
  sidebarHover: 'rgba(255,255,255,0.05)',
  sidebarAccent: '#818cf8',
  card: '#FFFFFF',
  cardBorder: 'rgba(0,0,0,0.10)',
  cardHover: '#FAF8F6',
  text: '#1a1520',
  textSecondary: '#5c5466',
  textMuted: '#908892',
  border: 'rgba(0,0,0,0.08)',
  accent: '#6366f1',
  accentLight: '#EEF0FF',
  accentText: '#4F46E5',
  inputBg: '#F3EFE9',
  inputBorder: 'rgba(0,0,0,0.1)',
  modalBg: '#FFFFFF',
  rowHover: '#F5F1EC',
  selectedRow: '#EEEAFF',
  selectedBorder: '#6366f1',
  shadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  shadowLg: '0 8px 30px rgba(0,0,0,0.08)',
};

// ─── SAMPLE DATA ───
const generateId = () => Math.random().toString(36).substr(2, 9);

const PRODUCTS = [
  { id: 'p1', name: 'Website Design', type: 'One-Time', price: 1500 },
  { id: 'p2', name: 'SEO Monthly', type: 'Retainer', price: 499, billing: 'Monthly' },
  { id: 'p3', name: 'Social Media Mgmt', type: 'Retainer', price: 799, billing: 'Monthly' },
  { id: 'p4', name: 'Google Ads Mgmt', type: 'Retainer', price: 599, billing: 'Monthly' },
  { id: 'p5', name: 'Logo & Branding', type: 'One-Time', price: 450 },
  { id: 'p6', name: 'Content Writing', type: 'Retainer', price: 349, billing: 'Monthly' },
  { id: 'p7', name: 'GBP Setup', type: 'One-Time', price: 88 },
  { id: 'p8', name: 'Video Production', type: 'One-Time', price: 1200 },
  { id: 'p9', name: 'Email Marketing', type: 'Retainer', price: 299, billing: 'Monthly' },
  { id: 'p10', name: 'Reputation Mgmt', type: 'Retainer', price: 399, billing: 'Monthly' },
];

const AGENTS = ['Marcus Cole', 'Aisha Patel', 'Jake Morrison', 'Sofia Chen', 'Tyler Brooks', 'Nadia Kovac', 'Ravi Singh', 'Emma Lawson'];
const AMS = ['Zara Khan', 'Liam Cooper', 'Priya Sharma'];
const TEAMS = ['Team Alpha', 'Team Bravo', 'Team Charlie'];
const SOURCES = ['PPC - Google', 'PPC - Facebook', 'PPC - Instagram', 'Organic', 'Referral', 'Cold Outreach'];
const STATUSES_LEAD = ['New', 'Contacted', 'Callback Scheduled', 'Interested', 'Proposal Sent', 'Negotiating', 'Won', 'Lost', 'No Answer', 'Voicemail', 'Not Interested', 'Recycled'];
const PRIORITIES = ['VVIP', 'VIP', 'High', 'Medium', 'Low'];
const HEALTH_LABELS = ['Excellent', 'Good', 'Fair', 'At Risk', 'Critical'];
const HEALTH_COLORS = { Excellent: '#059669', Good: '#16a34a', Fair: '#d97706', 'At Risk': '#ea580c', Critical: '#dc2626' };
const STATUS_COLORS = {
  New: '#6366f1', Contacted: '#3b82f6', 'Callback Scheduled': '#8b5cf6', Interested: '#059669',
  'Proposal Sent': '#d97706', Negotiating: '#ea580c', Won: '#16a34a', Lost: '#dc2626',
  'No Answer': '#6b7280', Voicemail: '#9ca3af', 'Not Interested': '#dc2626', Recycled: '#64748b',
};

const randomDate = (daysBack) => {
  const d = new Date(); d.setDate(d.getDate() - Math.floor(Math.random() * daysBack));
  return d.toISOString();
};
const fmtDate = (iso) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
const fmtTime = (iso) => new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
const fmtDateTime = (iso) => `${fmtDate(iso)} ${fmtTime(iso)}`;
const fmtMoney = (n) => '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 0 });
const daysAgo = (iso) => Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);

const initLeads = () => Array.from({ length: 42 }, (_, i) => {
  const status = STATUSES_LEAD[Math.floor(Math.random() * STATUSES_LEAD.length)];
  const isClient = status === 'Won';
  const health = isClient ? HEALTH_LABELS[Math.floor(Math.random() * HEALTH_LABELS.length)] : null;
  const healthScore = isClient ? Math.floor(Math.random() * 40 + 60) : null;
  const names = ['James Wilson', 'Maria Garcia', 'Robert Chen', 'Sarah Johnson', 'Michael Brown', 'Emily Davis', 'David Kim', 'Lisa Anderson', 'Chris Taylor', 'Jennifer Martinez', 'Alex Thompson', 'Rachel Moore', 'Daniel White', 'Amanda Harris', 'Kevin Lee', 'Michelle Clark', 'Brian Lewis', 'Jessica Robinson', 'Tom Walker', 'Laura Hall', 'Steven Young', 'Angela King', 'Patrick Wright', 'Katherine Lopez', 'Andrew Scott', 'Samantha Green', 'Nicholas Adams', 'Christina Baker', 'Joseph Nelson', 'Victoria Hill', 'Ryan Carter', 'Rebecca Mitchell', 'Brandon Roberts', 'Lauren Turner', 'Dylan Phillips', 'Megan Campbell', 'Justin Parker', 'Ashley Evans', 'Nathan Edwards', 'Heather Collins', 'Tyler Stewart', 'Stephanie Morris'];
  const companies = ['BluePeak Corp', 'Sunrise Bakery', 'Metro Dental', 'FastTrack Fitness', 'CloudNine Tech', 'Green Valley Farm', 'Urban Brew Co', 'Pacific Plumbing', 'Summit Law Group', 'Bright Smiles Ortho', 'Elite Auto Repair', 'Harmony Spa', 'TrueNorth Consulting', 'Coastal Realty', 'Peak Performance Gym', 'FreshStart Juicery', 'Diamond Construction', 'Pixel Perfect Design', 'Serenity Wellness', 'Pioneer Security', 'Atlas Logistics', 'Nova Digital', 'Redwood Financial', 'ClearView Windows', 'Monarch Insurance', 'Horizon Architects', 'Stellar Marketing', 'Cascade Roofing', 'Vanguard Legal', 'Phoenix Restoration', 'Azure Health Clinic', 'Golden State Moving', 'Prime Remodel', 'Liberty Tax Services', 'Zenith Engineering', 'Pinnacle Real Estate', 'Maple Street Cafe', 'Olympus Training', 'Crossroads Auto', 'Beacon Insurance', 'Sapphire Dental', 'Evergreen Landscaping'];
  const created = randomDate(90);
  const lastContact = randomDate(Math.floor(Math.random() * 30));
  const products = isClient ? [PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)], ...(Math.random() > 0.5 ? [PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)]] : [])] : [PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)]];
  const totalValue = products.reduce((s, p) => s + p.price, 0);
  const monthlyValue = products.filter(p => p.type === 'Retainer').reduce((s, p) => s + p.price, 0);
  return {
    id: generateId(), name: names[i], company: companies[i],
    email: names[i].toLowerCase().replace(' ', '.') + '@' + companies[i].toLowerCase().replace(/[^a-z]/g, '') + '.com',
    phone: `+1 (${Math.floor(Math.random() * 900 + 100)}) ${Math.floor(Math.random() * 900 + 100)}-${Math.floor(Math.random() * 9000 + 1000)}`,
    status, source: SOURCES[Math.floor(Math.random() * SOURCES.length)],
    agent: AGENTS[Math.floor(Math.random() * AGENTS.length)],
    team: TEAMS[Math.floor(Math.random() * TEAMS.length)],
    am: isClient ? AMS[Math.floor(Math.random() * AMS.length)] : null,
    priority: PRIORITIES[Math.floor(Math.random() * PRIORITIES.length)],
    health, healthScore, products, totalValue, monthlyValue,
    created, lastContact,
    renewalDate: isClient ? new Date(Date.now() + Math.floor(Math.random() * 180 + 30) * 86400000).toISOString() : null,
    notes: '', tags: isClient ? ['Active Client'] : [],
    activities: Array.from({ length: Math.floor(Math.random() * 8 + 2) }, () => ({
      id: generateId(),
      type: ['call', 'email', 'sms', 'meeting', 'note', 'voicemail'][Math.floor(Math.random() * 6)],
      date: randomDate(60),
      summary: ['Initial outreach call', 'Follow-up email sent', 'Discussed pricing options', 'Proposal presentation', 'Contract review', 'Onboarding call', 'Upsell discussion', 'Quarterly review', 'Payment follow-up', 'Support request'][Math.floor(Math.random() * 10)],
      details: 'Detailed notes about this interaction would go here. The client was receptive and asked follow-up questions.',
      agent: AGENTS[Math.floor(Math.random() * AGENTS.length)],
      duration: Math.floor(Math.random() * 30 + 2) + 'min',
      hasRecording: Math.random() > 0.6,
    })).sort((a, b) => new Date(b.date) - new Date(a.date)),
    orders: isClient ? Array.from({ length: Math.floor(Math.random() * 3 + 1) }, () => ({
      id: generateId(),
      product: PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)],
      date: randomDate(120),
      amount: Math.floor(Math.random() * 2000 + 200),
      billing: ['Monthly', 'Annual', 'One-Time'][Math.floor(Math.random() * 3)],
      status: ['Active', 'Completed', 'Pending'][Math.floor(Math.random() * 3)],
    })) : [],
  };
});

// ─── STYLES (LIGHT) ───
const css = {
  app: { display: 'flex', height: '100vh', fontFamily: "'DM Sans', -apple-system, sans-serif", background: T.bg, color: T.text, overflow: 'hidden' },
  sidebar: { width: 250, background: T.sidebar, display: 'flex', flexDirection: 'column', flexShrink: 0, overflow: 'hidden' },
  main: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  card: { background: T.card, border: `1px solid ${T.cardBorder}`, borderRadius: 12, padding: 16, boxShadow: T.shadow },
  btn: { padding: '7px 14px', borderRadius: 8, border: `1px solid ${T.border}`, background: T.card, color: T.textSecondary, cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, fontFamily: 'inherit', transition: 'all 0.15s', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' },
  btnPrimary: { padding: '8px 18px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #6366f1, #7c3aed)', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6, fontFamily: 'inherit', boxShadow: '0 2px 10px rgba(99,102,241,0.3)' },
  input: { background: T.inputBg, border: `1px solid ${T.inputBorder}`, borderRadius: 8, padding: '9px 12px', color: T.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', width: '100%' },
  select: { background: T.inputBg, border: `1px solid ${T.inputBorder}`, borderRadius: 8, padding: '9px 12px', color: T.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', cursor: 'pointer' },
  badge: (color) => ({ display: 'inline-flex', alignItems: 'center', padding: '3px 9px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: color + '14', color: color, letterSpacing: '0.3px' }),
  pill: (active) => ({ padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: active ? 600 : 400, border: active ? '1px solid rgba(99,102,241,0.35)' : `1px solid ${T.border}`, background: active ? T.accentLight : T.card, color: active ? T.accentText : T.textMuted, cursor: 'pointer', fontFamily: 'inherit', boxShadow: active ? 'none' : '0 1px 2px rgba(0,0,0,0.03)' }),
};

// ─── MODAL ───
const Modal = ({ open, onClose, title, children, width = 560 }) => {
  if (!open) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.25)', backdropFilter: 'blur(4px)' }} />
      <div onClick={e => e.stopPropagation()} style={{ width, maxHeight: '80vh', overflow: 'auto', position: 'relative', padding: 0, background: T.modalBg, borderRadius: 16, border: `1px solid ${T.cardBorder}`, boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: `1px solid ${T.border}` }}>
          <span style={{ fontSize: 16, fontWeight: 700, color: T.text }}>{title}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: T.textMuted, display: 'flex', padding: 4 }}>{I('x', 18)}</button>
        </div>
        <div style={{ padding: 20 }}>{children}</div>
      </div>
    </div>
  );
};

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 14 }}>
    <label style={{ display: 'block', fontSize: 12, color: T.textMuted, marginBottom: 5, fontWeight: 500 }}>{label}</label>
    {children}
  </div>
);

// ─── MAIN APP ───
const CRM = () => {
  const [leads, setLeads] = useState(() => initLeads());
  const [page, setPage] = useState('pipeline');
  const [selectedLead, setSelectedLead] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterHealth, setFilterHealth] = useState('all');
  const [pipelineView, setPipelineView] = useState('board');
  const [showAddLead, setShowAddLead] = useState(false);
  const [showAddActivity, setShowAddActivity] = useState(false);
  const [detailTab, setDetailTab] = useState('timeline');
  const [newLead, setNewLead] = useState({ name: '', company: '', email: '', phone: '', source: 'PPC - Google', agent: AGENTS[0] });
  const [newActivity, setNewActivity] = useState({ type: 'call', summary: '', details: '' });

  const clients = leads.filter(l => l.status === 'Won');
  const pipeline = leads.filter(l => l.status !== 'Won' && l.status !== 'Lost');
  const activeLeads = page === 'clients' ? clients : pipeline;

  const filtered = activeLeads.filter(l => {
    const q = searchQuery.toLowerCase();
    const matchQ = !q || l.name.toLowerCase().includes(q) || l.company.toLowerCase().includes(q) || l.email.toLowerCase().includes(q);
    const matchS = filterStatus === 'all' || l.status === filterStatus;
    const matchH = filterHealth === 'all' || l.health === filterHealth;
    return matchQ && matchS && (page !== 'clients' || matchH);
  });

  const stats = {
    totalLeads: pipeline.length,
    totalClients: clients.length,
    wonThisMonth: leads.filter(l => l.status === 'Won' && daysAgo(l.lastContact) <= 30).length,
    totalRevenue: clients.reduce((s, c) => s + c.totalValue, 0),
    monthlyRecurring: clients.reduce((s, c) => s + c.monthlyValue, 0),
    atRisk: clients.filter(c => c.health === 'At Risk' || c.health === 'Critical').length,
    avgHealth: clients.length ? Math.round(clients.reduce((s, c) => s + (c.healthScore || 0), 0) / clients.length) : 0,
  };

  const boardColumns = ['New', 'Contacted', 'Callback Scheduled', 'Interested', 'Proposal Sent', 'Negotiating'];

  const addLead = () => {
    const lead = {
      id: generateId(), ...newLead, status: 'New', team: TEAMS[0], priority: 'Medium',
      health: null, healthScore: null, products: [], totalValue: 0, monthlyValue: 0,
      created: new Date().toISOString(), lastContact: new Date().toISOString(),
      renewalDate: null, notes: '', tags: [], activities: [], orders: [], am: null,
    };
    setLeads(prev => [lead, ...prev]);
    setShowAddLead(false);
    setNewLead({ name: '', company: '', email: '', phone: '', source: 'PPC - Google', agent: AGENTS[0] });
  };

  const addActivity = () => {
    if (!selectedLead || !newActivity.summary) return;
    const activity = {
      id: generateId(), ...newActivity, date: new Date().toISOString(),
      agent: selectedLead.agent, duration: '-', hasRecording: false,
    };
    setLeads(prev => prev.map(l => l.id === selectedLead.id ? { ...l, activities: [activity, ...l.activities], lastContact: new Date().toISOString() } : l));
    setSelectedLead(prev => prev ? { ...prev, activities: [activity, ...prev.activities] } : null);
    setShowAddActivity(false);
    setNewActivity({ type: 'call', summary: '', details: '' });
  };

  const updateStatus = (leadId, newStatus) => {
    setLeads(prev => prev.map(l => {
      if (l.id !== leadId) return l;
      const isWin = newStatus === 'Won';
      return { ...l, status: newStatus, health: isWin ? 'Good' : l.health, healthScore: isWin ? 80 : l.healthScore, am: isWin && !l.am ? AMS[Math.floor(Math.random() * AMS.length)] : l.am, tags: isWin ? [...l.tags, 'Active Client'] : l.tags, renewalDate: isWin ? new Date(Date.now() + 365 * 86400000).toISOString() : l.renewalDate };
    }));
    if (selectedLead?.id === leadId) setSelectedLead(prev => prev ? { ...prev, status: newStatus } : null);
  };

  const activityIcon = (type) => ({ call: 'phone', email: 'mail', sms: 'msg', meeting: 'users', note: 'edit', voicemail: 'mic' }[type] || 'msg');
  const activityColor = (type) => ({ call: '#6366f1', email: '#3b82f6', sms: '#059669', meeting: '#d97706', note: '#8b5cf6', voicemail: '#ea580c' }[type] || '#6b7280');

  // ─── DETAIL PANEL ───
  const DetailPanel = () => {
    const lead = selectedLead;
    if (!lead) return (
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12, color: T.textMuted }}>
        {I('user', 48)}<span style={{ fontSize: 14 }}>Select a record to view details</span>
      </div>
    );
    const refreshLead = leads.find(l => l.id === lead.id) || lead;

    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: T.card }}>
        {/* Header */}
        <div style={{ padding: '18px 22px', borderBottom: `1px solid ${T.border}`, flexShrink: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                <span style={{ fontSize: 20, fontWeight: 700, color: T.text }}>{refreshLead.name}</span>
                <span style={css.badge(STATUS_COLORS[refreshLead.status] || '#6b7280')}>{refreshLead.status}</span>
                {refreshLead.priority === 'VVIP' && <span style={css.badge('#d97706')}>★ VVIP</span>}
                {refreshLead.priority === 'VIP' && <span style={css.badge('#8b5cf6')}>VIP</span>}
              </div>
              <div style={{ fontSize: 13, color: T.textSecondary }}>{refreshLead.company}</div>
            </div>
            <button onClick={() => setSelectedLead(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: T.textMuted, display: 'flex', padding: 4 }}>{I('x', 18)}</button>
          </div>
          {/* Contact */}
          <div style={{ display: 'flex', gap: 16, fontSize: 12, color: T.textMuted, flexWrap: 'wrap' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>{I('mail', 12)} {refreshLead.email}</span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>{I('phone', 12)} {refreshLead.phone}</span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>{I('user', 12)} {refreshLead.agent}</span>
            {refreshLead.am && <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>{I('shield', 12)} AM: {refreshLead.am}</span>}
          </div>
          {/* Stats cards */}
          <div style={{ display: 'flex', gap: 10, marginTop: 14, flexWrap: 'wrap' }}>
            {refreshLead.healthScore && (
              <div style={{ padding: '8px 14px', display: 'flex', alignItems: 'center', gap: 8, background: HEALTH_COLORS[refreshLead.health] + '0C', border: `1px solid ${HEALTH_COLORS[refreshLead.health]}25`, borderRadius: 10 }}>
                <div style={{ width: 30, height: 30, borderRadius: '50%', border: `2.5px solid ${HEALTH_COLORS[refreshLead.health]}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: HEALTH_COLORS[refreshLead.health] }}>{refreshLead.healthScore}</div>
                <div><div style={{ fontSize: 10, color: T.textMuted }}>Health</div><div style={{ fontSize: 12, fontWeight: 600, color: HEALTH_COLORS[refreshLead.health] }}>{refreshLead.health}</div></div>
              </div>
            )}
            <div style={{ padding: '8px 14px', background: T.inputBg, borderRadius: 10, border: `1px solid ${T.border}` }}>
              <div style={{ fontSize: 10, color: T.textMuted }}>Total Value</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: T.text }}>{fmtMoney(refreshLead.totalValue)}</div>
            </div>
            <div style={{ padding: '8px 14px', background: T.inputBg, borderRadius: 10, border: `1px solid ${T.border}` }}>
              <div style={{ fontSize: 10, color: T.textMuted }}>Monthly</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: T.text }}>{fmtMoney(refreshLead.monthlyValue)}</div>
            </div>
            {refreshLead.renewalDate && (
              <div style={{ padding: '8px 14px', background: T.inputBg, borderRadius: 10, border: `1px solid ${T.border}` }}>
                <div style={{ fontSize: 10, color: T.textMuted }}>Renewal</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: daysAgo(refreshLead.renewalDate) < -30 ? '#059669' : '#d97706' }}>
                  {Math.abs(Math.ceil((new Date(refreshLead.renewalDate) - Date.now()) / 86400000))}d
                </div>
              </div>
            )}
            <div style={{ padding: '8px 14px', background: T.inputBg, borderRadius: 10, border: `1px solid ${T.border}` }}>
              <div style={{ fontSize: 10, color: T.textMuted }}>Activities</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: T.text }}>{refreshLead.activities.length}</div>
            </div>
          </div>
          {/* Actions */}
          <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
            <button onClick={() => { setShowAddActivity(true); setNewActivity({ type: 'call', summary: '', details: '' }); }} style={css.btnPrimary}>{I('plus', 14)} Log Activity</button>
            <select value={refreshLead.status} onChange={e => updateStatus(refreshLead.id, e.target.value)} style={css.select}>
              {STATUSES_LEAD.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', gap: 0, borderBottom: `1px solid ${T.border}`, paddingLeft: 22, flexShrink: 0, background: T.card, overflowX: 'auto' }}>
          {[
            { key: 'timeline', label: 'Timeline', icon: 'clock' },
            { key: 'summary', label: 'Summary', icon: 'user' },
            { key: 'about', label: 'About', icon: 'file' },
            { key: 'orders', label: 'Orders', icon: 'box' },
            { key: 'comments', label: 'Comments', icon: 'msg' },
            { key: 'call', label: 'Call', icon: 'phone' },
            { key: 'sms', label: 'SMS', icon: 'msg' },
            { key: 'emails', label: 'Emails', icon: 'mail' },
          ].map(tab => (
            <button key={tab.key} onClick={() => setDetailTab(tab.key)} style={{
              padding: '11px 16px', background: 'none', border: 'none', cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 6,
              color: detailTab === tab.key ? T.accentText : T.textMuted,
              fontSize: 13, fontWeight: detailTab === tab.key ? 600 : 400,
              borderBottom: detailTab === tab.key ? `2px solid ${T.accent}` : '2px solid transparent',
              fontFamily: 'inherit', whiteSpace: 'nowrap',
            }}>
              {I(tab.icon, 14)} {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div style={{ flex: 1, overflow: 'auto', padding: 22 }}>
          {detailTab === 'timeline' && (
            <div>
              {refreshLead.activities.map((act, i) => (
                <div key={act.id} style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ width: 34, height: 34, borderRadius: '50%', background: activityColor(act.type) + '12', display: 'flex', alignItems: 'center', justifyContent: 'center', color: activityColor(act.type), flexShrink: 0 }}>
                      {I(activityIcon(act.type), 15)}
                    </div>
                    {i < refreshLead.activities.length - 1 && <div style={{ width: 1, flex: 1, background: T.border, marginTop: 4 }} />}
                  </div>
                  <div style={{ flex: 1, paddingBottom: 4 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{act.summary}</span>
                      <span style={{ fontSize: 11, color: T.textMuted }}>{fmtDateTime(act.date)}</span>
                    </div>
                    <div style={{ fontSize: 12, color: T.textMuted, marginBottom: 4 }}>
                      {act.type.charAt(0).toUpperCase() + act.type.slice(1)} · {act.agent} · {act.duration}
                    </div>
                    <div style={{ fontSize: 12, color: T.textSecondary, lineHeight: 1.6 }}>{act.details}</div>
                    {act.hasRecording && (
                      <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px', background: T.accentLight, borderRadius: 8, width: 'fit-content' }}>
                        <button style={{ background: 'none', border: 'none', color: T.accent, cursor: 'pointer', display: 'flex' }}>{I('play', 14)}</button>
                        <div style={{ width: 120, height: 3, background: T.border, borderRadius: 2 }}><div style={{ width: '0%', height: '100%', background: T.accent, borderRadius: 2 }} /></div>
                        <span style={{ fontSize: 10, color: T.textMuted }}>0:00</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
              {refreshLead.activities.length === 0 && <div style={{ textAlign: 'center', color: T.textMuted, padding: 40 }}>No activities logged yet</div>}
            </div>
          )}

          {detailTab === 'summary' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div style={css.card}>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Contact Information</div>
                <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: 10, fontSize: 13 }}>
                  <span style={{ color: T.textMuted }}>Full Name:</span>
                  <span style={{ color: T.text, fontWeight: 500 }}>{refreshLead.name}</span>
                  <span style={{ color: T.textMuted }}>Company:</span>
                  <span style={{ color: T.text, fontWeight: 500 }}>{refreshLead.company}</span>
                  <span style={{ color: T.textMuted }}>Email:</span>
                  <span style={{ color: T.text }}>{refreshLead.email}</span>
                  <span style={{ color: T.textMuted }}>Phone:</span>
                  <span style={{ color: T.text }}>{refreshLead.phone}</span>
                  <span style={{ color: T.textMuted }}>Source:</span>
                  <span style={{ color: T.text }}>{refreshLead.source}</span>
                  <span style={{ color: T.textMuted }}>Agent:</span>
                  <span style={{ color: T.text }}>{refreshLead.agent}</span>
                  {refreshLead.am && (
                    <>
                      <span style={{ color: T.textMuted }}>Account Manager:</span>
                      <span style={{ color: T.text }}>{refreshLead.am}</span>
                    </>
                  )}
                </div>
              </div>
              <div style={css.card}>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Quick Stats</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
                  <div>
                    <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 4 }}>Status</div>
                    <span style={css.badge(STATUS_COLORS[refreshLead.status] || '#6b7280')}>{refreshLead.status}</span>
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 4 }}>Priority</div>
                    <span style={css.badge(refreshLead.priority === 'VVIP' || refreshLead.priority === 'VIP' ? '#d97706' : '#6b7280')}>{refreshLead.priority}</span>
                  </div>
                  {refreshLead.health && (
                    <div>
                      <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 4 }}>Health</div>
                      <span style={{ fontSize: 13, fontWeight: 600, color: HEALTH_COLORS[refreshLead.health] }}>{refreshLead.health} ({refreshLead.healthScore})</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {detailTab === 'about' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div style={css.card}>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>About This Lead</div>
                <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: 10, fontSize: 13 }}>
                  <span style={{ color: T.textMuted }}>Created:</span>
                  <span style={{ color: T.text }}>{fmtDate(refreshLead.created)}</span>
                  <span style={{ color: T.textMuted }}>Last Contact:</span>
                  <span style={{ color: T.text }}>{fmtDate(refreshLead.lastContact)} ({daysAgo(refreshLead.lastContact)}d ago)</span>
                  <span style={{ color: T.textMuted }}>Team:</span>
                  <span style={{ color: T.text }}>{refreshLead.team}</span>
                  {refreshLead.renewalDate && (
                    <>
                      <span style={{ color: T.textMuted }}>Renewal Date:</span>
                      <span style={{ color: T.text }}>{fmtDate(refreshLead.renewalDate)}</span>
                    </>
                  )}
                </div>
              </div>
              <div style={css.card}>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Products & Services</div>
                {refreshLead.products.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {refreshLead.products.map((p, i) => (
                      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: T.inputBg, borderRadius: 8 }}>
                        <div>
                          <div style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{p.name}</div>
                          <div style={{ fontSize: 11, color: T.textMuted }}>{p.type} {p.billing ? `· ${p.billing}` : ''}</div>
                        </div>
                        <div style={{ fontSize: 14, fontWeight: 700, color: T.text }}>{fmtMoney(p.price)}</div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', color: T.textMuted, padding: 20 }}>No products assigned yet</div>
                )}
              </div>
              <div style={css.card}>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Tags</div>
                {refreshLead.tags.length > 0 ? (
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {refreshLead.tags.map((tag, i) => (
                      <span key={i} style={{ padding: '4px 10px', background: T.accentLight, color: T.accentText, fontSize: 12, borderRadius: 6, fontWeight: 500 }}>{tag}</span>
                    ))}
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', color: T.textMuted, padding: 20 }}>No tags added</div>
                )}
              </div>
            </div>
          )}

          {detailTab === 'orders' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {refreshLead.orders.map(order => (
                <div key={order.id} style={{ ...css.card, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 2 }}>{order.product.name}</div>
                    <div style={{ fontSize: 12, color: T.textMuted }}>{order.billing} · {fmtDate(order.date)}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 16, fontWeight: 700, color: T.text }}>{fmtMoney(order.amount)}</div>
                    <span style={css.badge(order.status === 'Active' ? '#059669' : order.status === 'Pending' ? '#d97706' : '#6b7280')}>{order.status}</span>
                  </div>
                </div>
              ))}
              {refreshLead.orders.length === 0 && <div style={{ textAlign: 'center', color: T.textMuted, padding: 40 }}>No orders yet</div>}
            </div>
          )}

          {detailTab === 'comments' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <textarea placeholder="Add a comment..." style={{ ...css.input, minHeight: 100, resize: 'vertical' }} />
              <button style={css.btnPrimary}>{I('send', 14)} Post Comment</button>
              <div style={{ marginTop: 12 }}>
                {refreshLead.activities.filter(a => a.type === 'note').slice(0, 3).map(note => (
                  <div key={note.id} style={{ ...css.card, marginBottom: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{note.agent}</span>
                      <span style={{ fontSize: 11, color: T.textMuted }}>{fmtDateTime(note.date)}</span>
                    </div>
                    <div style={{ fontSize: 13, color: T.textSecondary, lineHeight: 1.6 }}>{note.details}</div>
                  </div>
                ))}
                {refreshLead.activities.filter(a => a.type === 'note').length === 0 && (
                  <div style={{ textAlign: 'center', color: T.textMuted, padding: 40 }}>No comments yet</div>
                )}
              </div>
            </div>
          )}

          {detailTab === 'call' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={css.card}>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Make a Call</div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                  <input style={{ ...css.input, flex: 1 }} value={refreshLead.phone} readOnly />
                  <button style={css.btnPrimary}>{I('phone', 14)} Call Now</button>
                </div>
              </div>
              <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 8 }}>Call History</div>
              {refreshLead.activities.filter(a => a.type === 'call' || a.type === 'voicemail').map(call => (
                <div key={call.id} style={{ ...css.card, display: 'flex', gap: 12 }}>
                  <div style={{ width: 34, height: 34, borderRadius: '50%', background: activityColor(call.type) + '12', display: 'flex', alignItems: 'center', justifyContent: 'center', color: activityColor(call.type), flexShrink: 0 }}>
                    {I(activityIcon(call.type), 15)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{call.summary}</span>
                      <span style={{ fontSize: 11, color: T.textMuted }}>{fmtDateTime(call.date)}</span>
                    </div>
                    <div style={{ fontSize: 12, color: T.textMuted, marginBottom: 4 }}>{call.agent} · {call.duration}</div>
                    <div style={{ fontSize: 12, color: T.textSecondary }}>{call.details}</div>
                  </div>
                </div>
              ))}
              {refreshLead.activities.filter(a => a.type === 'call' || a.type === 'voicemail').length === 0 && (
                <div style={{ textAlign: 'center', color: T.textMuted, padding: 40 }}>No call history</div>
              )}
            </div>
          )}

          {detailTab === 'sms' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={css.card}>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Send SMS</div>
                <textarea placeholder="Type your message..." style={{ ...css.input, minHeight: 80, resize: 'vertical', marginBottom: 8 }} />
                <button style={css.btnPrimary}>{I('send', 14)} Send SMS</button>
              </div>
              <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 8 }}>SMS History</div>
              {refreshLead.activities.filter(a => a.type === 'sms').map(sms => (
                <div key={sms.id} style={{ ...css.card }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{sms.summary}</span>
                    <span style={{ fontSize: 11, color: T.textMuted }}>{fmtDateTime(sms.date)}</span>
                  </div>
                  <div style={{ fontSize: 12, color: T.textMuted, marginBottom: 4 }}>{sms.agent}</div>
                  <div style={{ fontSize: 13, color: T.textSecondary, lineHeight: 1.6 }}>{sms.details}</div>
                </div>
              ))}
              {refreshLead.activities.filter(a => a.type === 'sms').length === 0 && (
                <div style={{ textAlign: 'center', color: T.textMuted, padding: 40 }}>No SMS history</div>
              )}
            </div>
          )}

          {detailTab === 'emails' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={css.card}>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 12 }}>Compose Email</div>
                <input placeholder="Subject..." style={{ ...css.input, marginBottom: 8 }} />
                <textarea placeholder="Type your email message..." style={{ ...css.input, minHeight: 120, resize: 'vertical', marginBottom: 8 }} />
                <button style={css.btnPrimary}>{I('send', 14)} Send Email</button>
              </div>
              <div style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 8 }}>Email History</div>
              {refreshLead.activities.filter(a => a.type === 'email').map(email => (
                <div key={email.id} style={{ ...css.card }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{email.summary}</span>
                    <span style={{ fontSize: 11, color: T.textMuted }}>{fmtDateTime(email.date)}</span>
                  </div>
                  <div style={{ fontSize: 12, color: T.textMuted, marginBottom: 4 }}>From: {email.agent}</div>
                  <div style={{ fontSize: 13, color: T.textSecondary, lineHeight: 1.6 }}>{email.details}</div>
                </div>
              ))}
              {refreshLead.activities.filter(a => a.type === 'email').length === 0 && (
                <div style={{ textAlign: 'center', color: T.textMuted, padding: 40 }}>No email history</div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  // ─── RENDER ───
  return (
    <div style={css.app}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
        *{box-sizing:border-box;margin:0;padding:0;}
        ::-webkit-scrollbar{width:5px;height:5px}
        ::-webkit-scrollbar-track{background:transparent}
        ::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.12);border-radius:10px}
        ::placeholder{color:#A89F93}
        input:focus,select:focus,textarea:focus{border-color:rgba(99,102,241,0.4)!important;box-shadow:0 0 0 3px rgba(99,102,241,0.08)!important}
      `}</style>

      {/* ─── SIDEBAR (dark) ─── */}
      <div style={css.sidebar}>
        <div style={{ padding: '22px 18px 18px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 15, color: '#fff' }}>L</div>
            <div><div style={{ fontSize: 15, fontWeight: 700, color: '#fff', letterSpacing: '-0.3px' }}>Legendesk</div><div style={{ fontSize: 9.5, color: T.sidebarAccent, letterSpacing: '2px', textTransform: 'uppercase', fontWeight: 600 }}>CRM</div></div>
          </div>
        </div>

        <div style={{ padding: '14px 10px', flex: 1 }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.2)', textTransform: 'uppercase', letterSpacing: '1.5px', padding: '0 12px', marginBottom: 10 }}>Menu</div>
          {[
            { key: 'pipeline', label: 'Pipeline', icon: 'target', count: pipeline.length },
            { key: 'clients', label: 'Clients', icon: 'users', count: clients.length },
            { key: 'reports', label: 'Reports', icon: 'chart' },
          ].map(item => (
            <button key={item.key} onClick={() => { setPage(item.key); setSelectedLead(null); setFilterStatus('all'); setFilterHealth('all'); }} style={{
              display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 12px',
              borderRadius: 8, border: 'none', cursor: 'pointer', fontFamily: 'inherit',
              background: page === item.key ? T.sidebarActiveBg : 'transparent',
              color: page === item.key ? T.sidebarActive : T.sidebarText,
              fontSize: 13, fontWeight: page === item.key ? 600 : 400,
              marginBottom: 2, transition: 'all 0.15s',
            }}>
              {I(item.icon, 16)}
              <span style={{ flex: 1, textAlign: 'left' }}>{item.label}</span>
              {item.count != null && <span style={{ fontSize: 11, fontWeight: 600, background: page === item.key ? 'rgba(99,102,241,0.25)' : 'rgba(255,255,255,0.06)', padding: '2px 8px', borderRadius: 10, color: page === item.key ? T.sidebarAccent : 'rgba(255,255,255,0.35)' }}>{item.count}</span>}
            </button>
          ))}
        </div>

        <div style={{ padding: 16, borderTop: '1px solid rgba(255,255,255,0.08)', fontSize: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, color: 'rgba(255,255,255,0.4)' }}>
            <span>MRR</span><span style={{ color: '#34d399', fontWeight: 600 }}>{fmtMoney(stats.monthlyRecurring)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, color: 'rgba(255,255,255,0.4)' }}>
            <span>At Risk</span><span style={{ color: '#fb923c', fontWeight: 600 }}>{stats.atRisk}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', color: 'rgba(255,255,255,0.4)' }}>
            <span>Avg Health</span><span style={{ color: stats.avgHealth >= 70 ? '#34d399' : '#fbbf24', fontWeight: 600 }}>{stats.avgHealth}%</span>
          </div>
        </div>
      </div>

      {/* ─── MAIN ─── */}
      <div style={css.main}>
        {/* Top Bar */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', borderBottom: `1px solid ${T.border}`, flexShrink: 0, gap: 12, background: T.card }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: T.inputBg, border: `1px solid ${T.inputBorder}`, borderRadius: 10, padding: '7px 14px', flex: 1, maxWidth: 340 }}>
              <span style={{ color: T.textMuted }}>{I('search', 15)}</span>
              <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder={`Search ${page === 'clients' ? 'clients' : 'leads'}...`} style={{ background: 'none', border: 'none', outline: 'none', color: T.text, fontSize: 13, width: '100%', fontFamily: 'inherit' }} />
            </div>
            {page === 'pipeline' && (
              <div style={{ display: 'flex', gap: 4 }}>
                {['all', 'New', 'Contacted', 'Interested', 'Proposal Sent', 'Negotiating'].map(s => (
                  <button key={s} onClick={() => setFilterStatus(s)} style={css.pill(filterStatus === s)}>{s === 'all' ? 'All' : s}</button>
                ))}
              </div>
            )}
            {page === 'clients' && (
              <div style={{ display: 'flex', gap: 4 }}>
                {['all', ...HEALTH_LABELS].map(h => (
                  <button key={h} onClick={() => setFilterHealth(h)} style={css.pill(filterHealth === h)}>{h === 'all' ? 'All' : h}</button>
                ))}
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {page === 'pipeline' && (
              <div style={{ display: 'flex', background: T.inputBg, borderRadius: 8, border: `1px solid ${T.inputBorder}` }}>
                <button onClick={() => setPipelineView('board')} style={{ ...css.btn, border: 'none', borderRadius: '8px 0 0 8px', background: pipelineView === 'board' ? T.accentLight : 'transparent', color: pipelineView === 'board' ? T.accentText : T.textMuted, boxShadow: 'none' }}>{I('grid', 14)}</button>
                <button onClick={() => setPipelineView('table')} style={{ ...css.btn, border: 'none', borderRadius: '0 8px 8px 0', background: pipelineView === 'table' ? T.accentLight : 'transparent', color: pipelineView === 'table' ? T.accentText : T.textMuted, boxShadow: 'none' }}>{I('list', 14)}</button>
              </div>
            )}
            <button onClick={() => setShowAddLead(true)} style={css.btnPrimary}>{I('plus', 14)} Add {page === 'clients' ? 'Client' : 'Lead'}</button>
          </div>
        </div>

        {/* Content */}
        <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
          {page === 'reports' ? (
            <div style={{ flex: 1, overflow: 'auto', padding: 20 }}>
              {/* KPIs */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 24 }}>
                {[
                  { label: 'Total Revenue', value: fmtMoney(stats.totalRevenue), icon: 'dollar', color: '#059669' },
                  { label: 'MRR', value: fmtMoney(stats.monthlyRecurring), icon: 'refresh', color: '#6366f1' },
                  { label: 'Active Leads', value: stats.totalLeads, icon: 'target', color: '#3b82f6' },
                  { label: 'Clients', value: stats.totalClients, icon: 'users', color: '#8b5cf6' },
                  { label: 'Won (30d)', value: stats.wonThisMonth, icon: 'check', color: '#16a34a' },
                  { label: 'At Risk', value: stats.atRisk, icon: 'bell', color: '#ea580c' },
                ].map((kpi, i) => (
                  <div key={i} style={{ ...css.card, display: 'flex', alignItems: 'center', gap: 14 }}>
                    <div style={{ width: 42, height: 42, borderRadius: 10, background: kpi.color + '12', display: 'flex', alignItems: 'center', justifyContent: 'center', color: kpi.color, flexShrink: 0 }}>
                      {I(kpi.icon, 18)}
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 2 }}>{kpi.label}</div>
                      <div style={{ fontSize: 22, fontWeight: 700, color: T.text }}>{kpi.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Funnel */}
              <div style={{ ...css.card, marginBottom: 16 }}>
                <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 14, color: T.text }}>Pipeline Funnel</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {boardColumns.map(stage => {
                    const count = leads.filter(l => l.status === stage).length;
                    const pct = pipeline.length ? Math.round(count / pipeline.length * 100) : 0;
                    return (
                      <div key={stage} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <span style={{ width: 130, fontSize: 12, color: T.textSecondary, textAlign: 'right' }}>{stage}</span>
                        <div style={{ flex: 1, height: 26, background: T.inputBg, borderRadius: 8, overflow: 'hidden' }}>
                          <div style={{ width: `${pct}%`, height: '100%', background: `linear-gradient(90deg, ${STATUS_COLORS[stage]}, ${STATUS_COLORS[stage]}AA)`, borderRadius: 8, display: 'flex', alignItems: 'center', paddingLeft: 8, minWidth: pct > 0 ? 40 : 0 }}>
                            <span style={{ fontSize: 11, fontWeight: 600, color: '#fff' }}>{count}</span>
                          </div>
                        </div>
                        <span style={{ width: 36, fontSize: 11, color: T.textMuted, textAlign: 'right' }}>{pct}%</span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Leaderboard + Health */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <div style={css.card}>
                  <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 14, color: T.text }}>Agent Leaderboard</div>
                  {AGENTS.slice(0, 6).map((agent, i) => {
                    const agentLeads = leads.filter(l => l.agent === agent);
                    const won = agentLeads.filter(l => l.status === 'Won').length;
                    const total = agentLeads.length;
                    const convRate = total ? Math.round(won / total * 100) : 0;
                    return (
                      <div key={agent} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: i < 5 ? `1px solid ${T.border}` : 'none' }}>
                        <span style={{ width: 20, fontSize: 12, fontWeight: 700, color: i < 3 ? '#d97706' : T.textMuted, textAlign: 'center' }}>#{i + 1}</span>
                        <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#fff' }}>{agent.split(' ').map(n => n[0]).join('')}</div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{agent}</div>
                          <div style={{ fontSize: 11, color: T.textMuted }}>{total} leads · {won} won</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ fontSize: 15, fontWeight: 700, color: convRate >= 30 ? '#059669' : convRate >= 15 ? '#d97706' : '#dc2626' }}>{convRate}%</div>
                          <div style={{ fontSize: 10, color: T.textMuted }}>conv rate</div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div style={css.card}>
                  <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 14, color: T.text }}>Client Health Distribution</div>
                  {HEALTH_LABELS.map(h => {
                    const count = clients.filter(c => c.health === h).length;
                    const pct = clients.length ? Math.round(count / clients.length * 100) : 0;
                    return (
                      <div key={h} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                        <div style={{ width: 8, height: 8, borderRadius: '50%', background: HEALTH_COLORS[h] }} />
                        <span style={{ width: 70, fontSize: 12, color: T.textSecondary }}>{h}</span>
                        <div style={{ flex: 1, height: 8, background: T.inputBg, borderRadius: 4, overflow: 'hidden' }}>
                          <div style={{ width: `${pct}%`, height: '100%', background: HEALTH_COLORS[h], borderRadius: 4 }} />
                        </div>
                        <span style={{ width: 55, fontSize: 12, fontWeight: 600, textAlign: 'right', color: HEALTH_COLORS[h] }}>{count} ({pct}%)</span>
                      </div>
                    );
                  })}
                  <div style={{ marginTop: 16, padding: 12, background: T.inputBg, borderRadius: 10 }}>
                    <div style={{ fontSize: 12, color: T.textMuted, marginBottom: 8, fontWeight: 600 }}>Health Score Weights</div>
                    {[
                      { label: 'Payment', weight: '30%' },
                      { label: 'Engagement', weight: '20%' },
                      { label: 'Satisfaction', weight: '20%' },
                      { label: 'Tenure', weight: '15%' },
                      { label: 'Revenue Growth', weight: '15%' },
                    ].map(w => (
                      <div key={w.label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: T.textSecondary, marginBottom: 4 }}>
                        <span>{w.label}</span><span style={{ fontWeight: 600 }}>{w.weight}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* List / Board */}
              <div style={{ width: selectedLead ? 360 : '100%', borderRight: selectedLead ? `1px solid ${T.border}` : 'none', overflow: 'auto', transition: 'width 0.2s', flexShrink: 0, background: selectedLead ? T.bg : T.bg }}>
                {page === 'pipeline' && pipelineView === 'board' && !selectedLead ? (
                  <div style={{ display: 'flex', gap: 12, padding: 16, minWidth: 'fit-content', height: '100%' }}>
                    {boardColumns.map(stage => {
                      const stageLeads = filtered.filter(l => l.status === stage);
                      return (
                        <div key={stage} style={{ width: 260, flexShrink: 0, display: 'flex', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, padding: '8px 12px', background: T.card, borderRadius: 10, border: `1px solid ${T.border}`, boxShadow: T.shadow }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <div style={{ width: 10, height: 10, borderRadius: '50%', background: STATUS_COLORS[stage], boxShadow: `0 0 8px ${STATUS_COLORS[stage]}30` }} />
                              <span style={{ fontSize: 12, fontWeight: 700, color: T.text }}>{stage}</span>
                            </div>
                            <span style={{ fontSize: 11, fontWeight: 700, background: STATUS_COLORS[stage] + '12', color: STATUS_COLORS[stage], padding: '2px 8px', borderRadius: 8 }}>{stageLeads.length}</span>
                          </div>
                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8, overflow: 'auto' }}>
                            {stageLeads.map(lead => (
                              <div key={lead.id} onClick={() => setSelectedLead(lead)} style={{
                                ...css.card, cursor: 'pointer', padding: 14,
                                borderLeft: `3px solid ${STATUS_COLORS[stage]}`,
                                transition: 'all 0.15s',
                              }} onMouseEnter={e => { e.currentTarget.style.boxShadow = T.shadowLg; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                                onMouseLeave={e => { e.currentTarget.style.boxShadow = T.shadow; e.currentTarget.style.transform = 'translateY(0)'; }}>
                                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 2, color: T.text }}>{lead.name}</div>
                                <div style={{ fontSize: 11, color: T.textMuted, marginBottom: 8 }}>{lead.company}</div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <span style={{ fontSize: 13, fontWeight: 700, color: T.accentText }}>{fmtMoney(lead.totalValue || lead.products[0]?.price || 0)}</span>
                                  <span style={{ fontSize: 10, color: T.textMuted }}>{daysAgo(lead.lastContact)}d ago</span>
                                </div>
                                <div style={{ display: 'flex', gap: 4, marginTop: 8, flexWrap: 'wrap' }}>
                                  {lead.products.slice(0, 2).map((p, i) => (
                                    <span key={i} style={{ fontSize: 10, padding: '2px 7px', borderRadius: 4, background: T.inputBg, color: T.textSecondary, border: `1px solid ${T.border}` }}>{p.name}</span>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    <div style={{ display: 'grid', gridTemplateColumns: selectedLead ? '1fr' : '2fr 1.5fr 1fr 1fr 1fr 0.8fr', padding: '10px 16px', borderBottom: `1px solid ${T.border}`, position: 'sticky', top: 0, background: T.card, zIndex: 5 }}>
                      {selectedLead ? (
                        <span style={{ fontSize: 11, fontWeight: 600, color: T.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{filtered.length} {page === 'clients' ? 'Clients' : 'Leads'}</span>
                      ) : (
                        <>
                          <span style={{ fontSize: 11, fontWeight: 600, color: T.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Name</span>
                          <span style={{ fontSize: 11, fontWeight: 600, color: T.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Status</span>
                          <span style={{ fontSize: 11, fontWeight: 600, color: T.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Value</span>
                          <span style={{ fontSize: 11, fontWeight: 600, color: T.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Agent</span>
                          {page === 'clients' && <span style={{ fontSize: 11, fontWeight: 600, color: T.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Health</span>}
                          <span style={{ fontSize: 11, fontWeight: 600, color: T.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Last Contact</span>
                        </>
                      )}
                    </div>
                    {filtered.map(lead => (
                      <div key={lead.id} onClick={() => setSelectedLead(lead)} style={{
                        display: 'grid', gridTemplateColumns: selectedLead ? '1fr' : '2fr 1.5fr 1fr 1fr 1fr 0.8fr',
                        padding: '10px 16px', cursor: 'pointer',
                        borderBottom: `1px solid ${T.border}`,
                        background: selectedLead?.id === lead.id ? T.selectedRow : T.card,
                        borderLeft: selectedLead?.id === lead.id ? `2px solid ${T.selectedBorder}` : '2px solid transparent',
                        transition: 'all 0.1s',
                      }} onMouseEnter={e => { if (selectedLead?.id !== lead.id) e.currentTarget.style.background = T.rowHover; }}
                        onMouseLeave={e => { if (selectedLead?.id !== lead.id) e.currentTarget.style.background = T.card; }}>
                        {selectedLead ? (
                          <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div>
                                <div style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{lead.name}</div>
                                <div style={{ fontSize: 11, color: T.textMuted }}>{lead.company}</div>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <span style={css.badge(STATUS_COLORS[lead.status] || '#6b7280')}>{lead.status}</span>
                                {lead.healthScore && <span style={{ fontSize: 11, fontWeight: 600, color: HEALTH_COLORS[lead.health] }}>{lead.healthScore}</span>}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div>
                              <div style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{lead.name}</div>
                              <div style={{ fontSize: 11, color: T.textMuted }}>{lead.company}</div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={css.badge(STATUS_COLORS[lead.status] || '#6b7280')}>{lead.status}</span>
                            </div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{fmtMoney(lead.totalValue || lead.products[0]?.price || 0)}</div>
                            <div style={{ fontSize: 12, color: T.textSecondary }}>{lead.agent}</div>
                            {page === 'clients' && (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                {lead.healthScore && <span style={{ width: 26, height: 26, borderRadius: '50%', border: `2.5px solid ${HEALTH_COLORS[lead.health]}`, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700, color: HEALTH_COLORS[lead.health] }}>{lead.healthScore}</span>}
                                <span style={{ fontSize: 12, color: HEALTH_COLORS[lead.health], fontWeight: 500 }}>{lead.health}</span>
                              </div>
                            )}
                            <div style={{ fontSize: 12, color: T.textMuted }}>{daysAgo(lead.lastContact)}d ago</div>
                          </>
                        )}
                      </div>
                    ))}
                    {filtered.length === 0 && <div style={{ textAlign: 'center', padding: 60, color: T.textMuted }}>No records match your filters</div>}
                  </div>
                )}
              </div>

              {selectedLead && (
                <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
                  <DetailPanel />
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* ─── MODALS ─── */}
      <Modal open={showAddLead} onClose={() => setShowAddLead(false)} title={`Add New ${page === 'clients' ? 'Client' : 'Lead'}`}>
        <Field label="Full Name"><input style={css.input} value={newLead.name} onChange={e => setNewLead(p => ({ ...p, name: e.target.value }))} placeholder="John Smith" /></Field>
        <Field label="Company"><input style={css.input} value={newLead.company} onChange={e => setNewLead(p => ({ ...p, company: e.target.value }))} placeholder="Acme Corp" /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <Field label="Email"><input style={css.input} value={newLead.email} onChange={e => setNewLead(p => ({ ...p, email: e.target.value }))} placeholder="john@acme.com" /></Field>
          <Field label="Phone"><input style={css.input} value={newLead.phone} onChange={e => setNewLead(p => ({ ...p, phone: e.target.value }))} placeholder="+1 (555) 123-4567" /></Field>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <Field label="Source"><select style={{ ...css.select, width: '100%' }} value={newLead.source} onChange={e => setNewLead(p => ({ ...p, source: e.target.value }))}>{SOURCES.map(s => <option key={s}>{s}</option>)}</select></Field>
          <Field label="Assign Agent"><select style={{ ...css.select, width: '100%' }} value={newLead.agent} onChange={e => setNewLead(p => ({ ...p, agent: e.target.value }))}>{AGENTS.map(a => <option key={a}>{a}</option>)}</select></Field>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
          <button onClick={() => setShowAddLead(false)} style={css.btn}>Cancel</button>
          <button onClick={addLead} style={css.btnPrimary} disabled={!newLead.name}>{I('plus', 14)} Add {page === 'clients' ? 'Client' : 'Lead'}</button>
        </div>
      </Modal>

      <Modal open={showAddActivity} onClose={() => setShowAddActivity(false)} title="Log Activity">
        <Field label="Type">
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {['call', 'email', 'sms', 'meeting', 'note', 'voicemail'].map(t => (
              <button key={t} onClick={() => setNewActivity(p => ({ ...p, type: t }))} style={{ ...css.pill(newActivity.type === t), display: 'flex', alignItems: 'center', gap: 4 }}>
                {I(activityIcon(t), 12)} {t.charAt(0).toUpperCase() + t.slice(1)}
              </button>
            ))}
          </div>
        </Field>
        <Field label="Summary"><input style={css.input} value={newActivity.summary} onChange={e => setNewActivity(p => ({ ...p, summary: e.target.value }))} placeholder="Brief description of the interaction" /></Field>
        <Field label="Details"><textarea style={{ ...css.input, minHeight: 80, resize: 'vertical' }} value={newActivity.details} onChange={e => setNewActivity(p => ({ ...p, details: e.target.value }))} placeholder="Full notes, key points discussed, action items..." /></Field>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
          <button onClick={() => setShowAddActivity(false)} style={css.btn}>Cancel</button>
          <button onClick={addActivity} style={css.btnPrimary} disabled={!newActivity.summary}>{I('plus', 14)} Log Activity</button>
        </div>
      </Modal>
    </div>
  );
};

export default CRM;